import React from 'react';
import Layout from '../../../components/layouts/Layout';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useOwnersByAdmin } from '../../../hooks/admin/owners.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import OwnersListTable from '../../../components/admin/owner/OwnerListTable';
import EmptyData from '../../../components/ui/EmptyData';
import Pagination from '../../../components/ui/Pagination';
import OwnerSearchForm from '../../../components/admin/owner/OwnerSearchForm';
import { cities } from '../../../data/cities';
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';

const AdminViewOwnersPage: React.FC = () => {
      const { t } = useTranslation();
         const [searchParams,setSearchParams] = useSearchParams();
          const category = searchParams.get('category')??"";
          const pageQuery = Number(searchParams.get('page')) || 1;
          const name = searchParams.get('name')?? "";
          const phone = searchParams.get('phone')?? "";
          const city = searchParams.get('city')?? "";
          const email = searchParams.get('email')?? "";

           const categories = [
                  { id: "complete", name: t("completed_profiles") },
                  { id: "uncomplete" , name: t("not_completed_profiles") },
              ];

           const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };

      const {data, isLoading,isError} = useOwnersByAdmin({page:pageQuery,email,name,phone,city,isCompletedProfile:category});
  

  return (
    <Layout title={t("admin_sidebar.owners")} headline={""}>
      <CategoriesSection
        selectedCategory={category}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={""}
        buttonLabel=''
        showAdd={false}
        notShowAddButton={true}
      />
          <OwnerSearchForm cities={cities}/>
          <LoadingErrorState
            isError={isError}
            isLoading={isLoading}
            />
         {data && 
              (
                data.data.length===0 
                ?
                <EmptyData/>
                :
              <>
              <OwnersListTable owners={data.data}/>
              <Pagination
              handlePagination={handlePagination}
              totalPages={data.totalPages}
              currentPage={pageQuery}
              />
              </>
              )
              }
    </Layout>
  );
};

export default AdminViewOwnersPage;
